import PropTypes from "prop-types"
import React from "react"
import { FixedSizeList } from "react-window"

import OverflowMenu from "src/components/OverflowMenu"

const ITEM_HEIGHT = 36
const MAX_HEIGHT = 200

const VirtualizedInvoiceItemList = ({
  queryableInvoiceItems,
  currentProduct,
  apideckInvoiceItem,
  isMutatingInvoiceItem,
  mutateInvoiceItem,
}) => {
  // Total items = 1 reset option + invoice items
  const itemCount = 1 + queryableInvoiceItems.length

  // Calculate optimal height based on number of items
  const listHeight = Math.min(itemCount * ITEM_HEIGHT, MAX_HEIGHT)

  // Render function for each row
  // eslint-disable-next-line react/prop-types
  const Row = ({ index, style }) => {
    // Index 0 = reset option
    if (index === 0) {
      return (
        <div style={style}>
          <OverflowMenu.Item
            label="(reset)"
            onClick={() => {
              mutateInvoiceItem({
                id: apideckInvoiceItem?.id,
                data: {
                  id: apideckInvoiceItem?.id,
                  product_id: currentProduct.id,
                },
              })
            }}
            disabled={!apideckInvoiceItem?.productId || isMutatingInvoiceItem}
          >
            (reset)
          </OverflowMenu.Item>
        </div>
      )
    }

    // Index 1+ = invoice items
    const invoiceItem = queryableInvoiceItems[index - 1]
    return (
      <div style={style}>
        <OverflowMenu.Item
          key={invoiceItem.id}
          label={invoiceItem.name}
          onClick={() => {
            mutateInvoiceItem({
              id: invoiceItem.id,
              data: { id: invoiceItem.id, product_id: currentProduct.id },
            })
          }}
          disabled={!!invoiceItem.productId || isMutatingInvoiceItem}
        >
          {invoiceItem.name}
        </OverflowMenu.Item>
      </div>
    )
  }

  return (
    <div
      onMouseDown={(e) => {
        // Prevent search field blur to allow click to complete
        e.preventDefault()
      }}
    >
      <FixedSizeList
        height={listHeight}
        itemCount={itemCount}
        itemSize={ITEM_HEIGHT}
        width="100%"
      >
        {Row}
      </FixedSizeList>
    </div>
  )
}

VirtualizedInvoiceItemList.propTypes = {
  queryableInvoiceItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  currentProduct: PropTypes.shape({
    id: PropTypes.number.isRequired,
    apideckInvoiceItem: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      productId: PropTypes.number,
    }),
  }).isRequired,
  apideckInvoiceItem: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    productId: PropTypes.number,
  }),
  isMutatingInvoiceItem: PropTypes.bool.isRequired,
  mutateInvoiceItem: PropTypes.func.isRequired,
}

export default VirtualizedInvoiceItemList
